// extracted by mini-css-extract-plugin
module.exports = {"date-picker__overlay":"BasicDatePicker_date-picker__overlay__TlJXj","date-picker":"BasicDatePicker_date-picker__awi5G"};